import { useState } from "react";

function useUploadError() {
  const [error, setError] = useState<string | null>(null);

  const showError = (msg: string) => {
    setError(msg);
  };

  const clearError = () => {
    setError(null);
  };

  return {
    error,
    showError,
    clearError,
  };
}

export default useUploadError;
